<template>
  <ab-modal
    title="询盘详情"
    :visible="visible"
    :confirm-loading="confirmLoading"
    footer=" "
    @cancel="handleCancel"
    width="100%"
  >
    <div class="inquiry-modal-body">
      <div class="body-content">
        <div class="detail-demand">
          <div class="demand-title fontSize20">询盘内容</div>
          <div class="demand-content fontSize18">
            {{ detailData.demand }}
          </div>
        </div>
        <div class="clearfix body-center">
          <a-row :gutter="[0, 16]">
            <a-col :span="6">
              <div class="item">
                <div class="item-title fontSize20">询盘时间</div>
                <div class="item-content fontSize14">
                  {{ detailData.time }}
                </div>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="item">
                <div class="item-title fontSize20">来源国家</div>
                <div class="item-content fontSize14">
                  {{ detailData.country }}
                </div>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="item">
                <div class="item-title fontSize20">联系人</div>
                <div class="item-content fontSize14">
                  {{
                    detailData.contactPerson && detailData.contactPerson.name
                      ? detailData.contactPerson.name
                      : ""
                  }}
                </div>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="item">
                <div class="item-title fontSize20">联系人职位</div>
                <div class="item-content fontSize14">
                  {{ detailData.post }}
                </div>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="item item-opacity">
                <div class="item-title fontSize20">相关行业</div>
                <div class="item-content fontSize14">
                  {{ detailData.industry }}
                </div>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="item item-opacity">
                <div class="item-title fontSize20">联系方式</div>
                <div class="item-content fontSize14">
                  {{
                    detailData.contactPerson && detailData.contactPerson.phone
                      ? detailData.contactPerson.phone
                      : ""
                  }}
                  {{
                    detailData.contactPerson && detailData.contactPerson.email
                      ? detailData.contactPerson.email
                      : ""
                  }}
                  {{
                    detailData.contactPerson && detailData.contactPerson.tel
                      ? detailData.contactPerson.tel
                      : ""
                  }}
                </div>
              </div>
            </a-col>
          </a-row>
        </div>
        <div class="modal-login">
          <ab-modal-login-btn-vue>
            <span slot="action-title"></span>
          </ab-modal-login-btn-vue>
        </div>
      </div>
    </div>
  </ab-modal>
</template>

<script>
// import { inquiryDetail } from '@/api/inquiry';
import moment from "moment";
import AbModal from "@/components/AbModal.vue";
import AbModalLoginBtnVue from "@/components/AbModalLoginBtn.vue";

export default {
  props: ["visible", "detailRecord"],
  components: {
    AbModalLoginBtnVue,
    AbModal,
  },
  data() {
    return {
      confirmLoading: false,
      // form: this.$form.createForm(this, { name: 'dynamic_rule' }),
      detailData: {},
    };
  },

  mounted() {
    // console.log(this.record, '------this.record------');
  },

  watch: {
    // watch 监听 props 中的值
    detailRecord(newObj, oldObj) {
      if (newObj.id !== oldObj.id) {
        // this.fetchDetail(newVal);
        let newData = { ...newObj };

        if (newData.country instanceof Array) {
          let dataArr = [];
          newData.country.forEach((element) => {
            element.cname && dataArr.push(element.cname);
          });
          newData.country = dataArr.join(",");
        } else {
          newData.country = "";
        }

        if (newData.industry instanceof Array) {
          let industryArr = [];
          newData.industry.forEach((element) => {
            element.cname && industryArr.push(element.cname);
          });
          newData.industry = industryArr.join(",");
        } else {
          newData.industry = "";
        }

        if (newData.contactPerson instanceof Array) {
          let contactPersonArr = [];
          newData.contactPerson.forEach((element) => {
            element.post && contactPersonArr.push(element.post);
          });
          newData.post = contactPersonArr.join(",");
        } else {
          newData.post = "";
        }

        newData.time = moment(newData.time).format("YYYY-MM-DD HH:mm:ss");

        this.detailData = newData;
      }
    },
  },

  methods: {
    handleCancel(e) {
      // this.visible = false;
      this.$emit("cancel");
    },

    // fetchDetail(id) {
    //   inquiryDetail({ id }).then((response) => {
    //     console.log(response, '=======response========');
    //     this.detailData = response.data;
    //   });
    // },
  },
};
</script>

<style lang="sass" scoped>
.inquiry-modal-body{
  height: calc(100vh - 200px);
  padding:40px 80px;
  .body-content{
    padding: 30px 40px ;
    background: #f9faff;
    border-radius: 8px;
    border: 1px solid #DCE6FF;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}

.detail-demand{
  height: 20%;
  .demand-title{
    font-family: AlibabaPuHuiTiM;
    font-weight: normal;
    color: #333646;
    line-height: 27px;
    font-size:20px;
  }
  .demand-content{
    padding-top: 12px;
    height: 130px;
    font-family: Alibaba-PuHuiTi-R;
    color: #333646;
    line-height: 25px;
     font-size:18px;
  }
}

.item{
  padding-bottom: 40px;
}
.item-title{
  position: relative;
  padding-left: 17px;
  height: 27px;
  font-family: AlibabaPuHuiTiM;
  font-weight: normal;
  color: #2B68FF;
  line-height: 27px;
      font-size: 20px;

}

.item-title:before{
    position: absolute;
    content: ' ';
    width: 4px;
    height: 27px;
    left: 0px;
    line-height: 27px;
    background: linear-gradient(230deg, #198BFF 0%, #217AF9 100%);
  }

.item-content{
  padding-top: 17px;
  height: 28px;
  font-family: Alibaba-PuHuiTi-R;
  font-weight: normal;
  color: #333646;
}

.body-center{
  height: 60%
}
.modal-login{
  height: 20%;
}

.item-opacity{
  opacity: 0.6;
}
</style>
